###
  Autosize widget
###

class INTENT.widgets.Autosize

  @ATTR_NAME: "data-widget-autosize"

  constructor: (@el) ->
    @s = @.constructor

    @el.addClass 'dynamic-height'
    autosize @el